import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const MetaTags = () => {
    const location = useLocation();
    const { i18n } = useTranslation();
    const [metaData, setMetaData] = useState<any>({});
    const language = i18n.language === "fr" ? "fr" : "en";

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/meta/translations/${language}.json`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch ${language}.json`);
                }
                return response.json();
            })
            .then((data) => setMetaData(data))
            .catch((error) => {
                console.error("Error loading meta data:", error);
                setMetaData({});
            });
    }, [language]);

    const matchedKey: any = Object.keys(metaData).find((key) =>
        location.pathname
            .toLowerCase()
            .replace(/\/$/, '')
            .replaceAll('-', '')
            .split('/')
            .at(-1)
            ?.includes(key)
    );

    const currentMeta = metaData[matchedKey] || {
        ogTitle: "Air Canada NDC",
        ogDescription: "Air Canada is unlocking new value for travel sellers thanks to its new distribution capabilities bringing a modern shopping experience.",
        ogImage: "/preview-meta1.png",
        ogUrl: location.pathname,
        ogType: "website",
        ogImageAlt: "Air Canada Logo",
    };

    return (
        <Helmet>
            <title>{currentMeta.ogTitle}</title>
            <meta name="description" content={currentMeta.ogDescription} />
            <meta property="og:title" content={currentMeta.ogTitle} />
            <meta property="og:description" content={currentMeta.ogDescription} />
            <meta property="og:image" content={currentMeta.ogImage} />
            <meta property="og:url" content={currentMeta.ogUrl} />
            <meta property="og:type" content={currentMeta.ogType} />
            <meta property="og:image:alt" content={currentMeta.ogImageAlt} />
        </Helmet>
    );
};

export default MetaTags;